import React from 'react';

// Stroke-based animal-face line icon so it colours with the sidebar's white icon
// treatment. The old version used a grey (#8F9497) fill plus a white 24x24
// background rect.
const ManageLivestock = () => {
  return (
    <div className="sidebar-icon">
      <svg
        className="sidebar-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Ears */}
        <path
          d="M6.5 8C4.7 7.3 3.3 5.6 4 4.2C4.6 3.1 6.2 3.4 7.3 5.2"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        <path
          d="M17.5 8C19.3 7.3 20.7 5.6 20 4.2C19.4 3.1 17.8 3.4 16.7 5.2"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        {/* Face */}
        <path
          d="M6 9.5C6 6.74 8.69 5 12 5C15.31 5 18 6.74 18 9.5V12.5C18 15.81 15.31 18.5 12 18.5C8.69 18.5 6 15.81 6 12.5V9.5Z"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        {/* Eyes */}
        <path
          d="M9.5 10.5H9.51"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        <path
          d="M14.5 10.5H14.51"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        {/* Muzzle */}
        <path
          d="M9.5 14.5C10.6 15.4 13.4 15.4 14.5 14.5"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
      </svg>
    </div>
  );
};

export default ManageLivestock;
